import { ThemeProp } from "../../../styles/theme";
import styled from "@emotion/styled";

export const TokensFirstRow = styled.div<ThemeProp>(({ theme }) => ({
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  color: theme.font.primary.default,
  fontWeight: theme.fontWeights["work-sans-0"],
  fontSize: theme.fontSize["5"],
  whiteSpace: "nowrap",
}));
